import { ErrorBox } from "../shared/error-box";
import { getErrorMessage } from "./utils";

/**
 * @param extraInfo - Extra information to display in the error message
 */
export function Forbidden({ extraInfo }: { extraInfo?: string }) {
  return <ErrorBox>{getErrorMessage("forbidden", extraInfo)}</ErrorBox>;
}
